/* ==========================================================================
   MAĞAZADA BUL / STORE FINDER  —  assets/store-finder.js
   Vanilla JS, bağımsız (jQuery vb. gerektirmez). Tema-bağımsız.
   ========================================================================== */
(function () {
  'use strict';

  function initAll() {
    document.querySelectorAll('[data-store-finder]').forEach(function (root) {
      if (root.__sfInit) return;
      root.__sfInit = true;
      new StoreFinder(root);
    });
  }

  function StoreFinder(root) {
    this.root = root;
    this.endpoint = root.dataset.endpoint || '';
    this.mock = root.dataset.mock === 'true';
    this.lowThreshold = parseInt(root.dataset.lowThreshold, 10) || 3;
    this.storesUrl = root.dataset.storesUrl || '';

    // DOM
    this.overlay      = root.querySelector('[data-sf-overlay]');
    this.dialog       = root.querySelector('.store-finder__dialog');
    this.citySel      = root.querySelector('[data-sf-city]');
    this.districtSel  = root.querySelector('[data-sf-district]');
    this.list         = root.querySelector('[data-sf-list]');
    this.emptyEl      = root.querySelector('[data-sf-empty]');
    this.loadingEl    = root.querySelector('[data-sf-loading]');
    this.errorEl      = root.querySelector('[data-sf-error]');
    this.noticeEl     = root.querySelector('[data-sf-notice]');
    this.variantRow   = root.querySelector('[data-sf-variant-row]');
    this.variantTitle = root.querySelector('[data-sf-variant-title]');

    // Konum (geolocation) durumu
    this.nearLimit = parseInt(root.dataset.nearLimit, 10) || 5;
    this.userPos   = null;    // { lat, lng } — izin verilirse dolar
    this.nearMode  = false;   // true iken şehir filtresi yerine mesafe sıralaması

    // Modal'ı <body>'nin doğrudan altına taşı (portal). Tetikleyici buton artık
    // variant-picker > fieldset > option-selector__header gibi derin bir DOM
    // ağacının içinde; o ağaçtaki herhangi bir üst eleman transform/overflow:
    // hidden/contain kullanıyorsa position:fixed olan overlay tüm ekrana değil
    // o üst elemana göre konumlanır ("kesik" görünen buydu). Overlay'i body'ye
    // taşımak bunu kalıcı olarak çözer, tetikleyici buton yerinde kalır.
    if (this.overlay && this.overlay.parentNode !== document.body) {
      document.body.appendChild(this.overlay);
    }

    // Data
    this.variants = this._readJSON('[data-sf-variants]') || { variants: [] };
    this.variantById = {};
    (this.variants.variants || []).forEach(function (v) { this.variantById[v.id] = v; }, this);
    this.stores = normalizeStores(this._readJSON('[data-sf-stores]') || []);

    this._stockCache = {};   // { variantId: { storeCode: qty } }
    this._lastRender = null; // yeniden çizim için

    this._bind();
    this._bindGeo();
    this._loadStoresFallback(); // metaobject boşsa JSON asset'ten çek
  }

  StoreFinder.prototype._readJSON = function (sel) {
    var scope = (this.root && this.root.isConnected) ? this.root : document;
    var el = scope.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  };

  /* ---- Mağaza rehberi: metaobject + JSON asset ----
     İki durumda JSON dosyasına başvurulur:
       a) Metaobject hiç kayıt döndürmediyse → JSON tam kaynak olarak kullanılır
       b) Metaobject dolu ama KOORDİNAT eksikse → JSON'dan sadece lat/lng
          alınıp 'code' üzerinden eşleştirilir. Böylece metaobject tanımına
          lat/lng alanı eklenip 24 kayda elle koordinat girilmesi gerekmez.
  -------------------------------------------------------------------- */
  StoreFinder.prototype._loadStoresFallback = function () {
    var self = this;
    var varMi = this.stores && this.stores.length;
    var koordinatEksik = varMi && this.stores.some(function (s) {
      return typeof s.lat !== 'number' || typeof s.lng !== 'number';
    });

    // Kayıt var ve koordinatlar tamsa dosyaya hiç gitme
    if (varMi && !koordinatEksik) { this._buildCityOptions(); return; }
    if (!this.storesUrl) { this._buildCityOptions(); return; }

    fetch(this.storesUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (data) {
        var list = normalizeStores(Array.isArray(data) ? data : []);
        if (!varMi) {
          // (a) Metaobject boştu — JSON'u tam kaynak yap
          self.stores = list;
          return;
        }
        // (b) Metaobject dolu — yalnızca eksik koordinatları tamamla
        var koordinat = {};
        list.forEach(function (s) {
          if (s.code && typeof s.lat === 'number' && typeof s.lng === 'number') {
            koordinat[s.code] = { lat: s.lat, lng: s.lng };
          }
        });
        self.stores.forEach(function (s) {
          if (typeof s.lat === 'number' && typeof s.lng === 'number') return;
          var k = koordinat[s.code];
          if (k) { s.lat = k.lat; s.lng = k.lng; }
        });
      })
      .catch(function () { if (!varMi) self.stores = []; })
      .then(function () {
        self._buildCityOptions();
        // Koordinatlar sonradan geldiyse açık listeyi tazele
        if (self.nearMode && self.userPos) self.render();
      });
  };

  StoreFinder.prototype._bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-sf-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.open(); });
    });
    this.overlay.querySelectorAll('[data-sf-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });
    this.overlay.addEventListener('click', function (e) {
      if (e.target === self.overlay) self.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.overlay.hidden) self.close();
    });

    this.citySel.addEventListener('change', function () {
      // Kullanıcı elle şehir seçtiyse konum modundan çık
      if (self.citySel.value) self._exitNearMode();
      self._buildDistrictOptions();
      self.render();
    });
    this.districtSel.addEventListener('change', function () { self.render(); });

    // Tema varyant değişimini yakala (form üzerindeki [name="id"])
    var form = this._productForm();
    if (form) {
      form.addEventListener('change', function () { self._onVariantChange(); });
    }
  };

  /* ---- Seçili varyantı temadan oku ---- */
  StoreFinder.prototype._productForm = function () {
    return document.querySelector('form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]');
  };
  StoreFinder.prototype._selectedVariantId = function () {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"]');
    return input ? String(input.value) : null;
  };
  StoreFinder.prototype._selectedVariant = function () {
    var id = this._selectedVariantId();
    if (!id) return null;
    var v = this.variantById[id];
    // Tema, variant-picker'ı sayfa yüklendikten sonra yeniden render edebiliyor
    // (Symmetry section rendering). Bu durumda yapıcıda okunan kopya eski kalır
    // ve metafield'daki stok görünmez. Elimizdeki kayıtta stok yoksa veri
    // bloğunu DOM'dan tazeleyip tekrar bakıyoruz.
    if (!v || !v.stock) {
      var fresh = this._readJSON('[data-sf-variants]');
      if (fresh && fresh.variants && fresh.variants.length) {
        this.variants = fresh;
        this.variantById = {};
        fresh.variants.forEach(function (x) { this.variantById[x.id] = x; }, this);
        this._stockCache = {};
        v = this.variantById[id] || v;
      }
    }
    return v || null;
  };

  StoreFinder.prototype._onVariantChange = function () {
    if (this.overlay.hidden) return;
    this._syncVariantUI();
    // Yeni varyant için stoğu tazele
    this.render(true);
  };

  StoreFinder.prototype._syncVariantUI = function () {
    var v = this._selectedVariant();
    if (v) {
      this.noticeEl.hidden = true;
      this.variantRow.hidden = false;
      this.variantTitle.textContent = v.title || '—';
    } else {
      this.noticeEl.hidden = false;
      this.variantRow.hidden = true;
    }
  };

  /* ---- Aç/Kapat ---- */
  StoreFinder.prototype.open = function () {
    this.overlay.hidden = false;
    document.documentElement.classList.add('sf-lock');
    this._syncVariantUI();
    var self = this;
    requestAnimationFrame(function () {
      self.overlay.classList.add('is-open');
      self.dialog.focus();
    });
    if (this.citySel.value || this.nearMode) this.render(true);
    else this._autoGeo();
  };
  StoreFinder.prototype.close = function () {
    var self = this;
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('sf-lock');
    setTimeout(function () { self.overlay.hidden = true; }, 220);
  };

  /* ==================================================================
     KONUM (GEOLOCATION) — "En yakın mağazayı bul"
     --------------------------------------------------------------
     Tarayıcı konum API'si yalnızca HTTPS'te ve KULLANICI İZNİ ile
     çalışır; izin istemi butona basıldığında çıkar (kendiliğinden
     sorulmaz). İzin verilmezse modül şehir seçimiyle çalışmaya devam
     eder — hiçbir özellik kaybolmaz.
     ================================================================== */
  StoreFinder.prototype._bindGeo = function () {
    this.geoStatus = this.overlay.querySelector('[data-sf-geo-status]');
    this.geoOn = root_geoEnabled(this.root) &&
                 ('geolocation' in navigator) && window.isSecureContext;
    this._geoTried = false;
  };

  function root_geoEnabled(root) {
    return root.dataset.geo !== 'false';
  }

  /* Modal ilk açıldığında konumu bir kez ister. Tarayıcı izin istemi burada
     çıkar; reddedilirse bir daha sorulmaz ve şehir seçimine düşülür. */
  StoreFinder.prototype._autoGeo = function () {
    if (this._geoTried || !this.geoOn) return;
    this._geoTried = true;

    var self = this;
    // Daha önce reddedilmişse istem çıkarmadan sessizce geç
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' })
        .then(function (p) {
          if (p.state === 'denied') {
            self._setGeoStatus('Konum izni kapalı. Şehir seçerek arama yapabilirsiniz.', '');
          } else {
            self._requestGeo();
          }
        })
        .catch(function () { self._requestGeo(); });
    } else {
      this._requestGeo();
    }
  };

  StoreFinder.prototype._setGeoStatus = function (msg, cls) {
    if (!this.geoStatus) return;
    this.geoStatus.textContent = msg || '';
    this.geoStatus.className = 'store-finder__geo-status' + (cls ? ' is-' + cls : '');
    this.geoStatus.hidden = !msg;
  };

  StoreFinder.prototype._requestGeo = function () {
    var self = this;
    this._setGeoStatus('Konumunuz alınıyor…', 'loading');

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.userPos = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        self.nearMode = true;
        // Konum modunda şehir/ilçe filtreleri devre dışı
        self.citySel.value = '';
        self.districtSel.innerHTML = '<option value="">Tümü</option>';
        self.districtSel.disabled = true;
        self.render(true);
      },
      function (err) {
        var msg = 'Konum alınamadı. Şehir seçerek devam edebilirsiniz.';
        if (err) {
          if (err.code === 1) msg = 'Konum izni verilmedi. Şehir seçerek arama yapabilirsiniz.';
          else if (err.code === 3) msg = 'Konum isteği zaman aşımına uğradı. Şehir seçebilirsiniz.';
        }
        self._setGeoStatus(msg, '');
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  };

  StoreFinder.prototype._exitNearMode = function () {
    this.nearMode = false;
    this._setGeoStatus('', '');
  };

  /* İki koordinat arası kuş uçuşu mesafe (km) — Haversine */
  function haversineKm(a, b) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad;
    var dLng = (b.lng - a.lng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a.lat * rad) * Math.cos(b.lat * rad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function formatKm(km) {
    if (km < 1) return Math.round(km * 1000) + ' m';
    if (km < 10) return km.toFixed(1).replace('.', ',') + ' km';
    return Math.round(km) + ' km';
  }

  /* Mağaza listesine mesafe ekleyip yakından uzağa sıralar.
     Koordinatı olmayan mağazalar sona atılır (listeden düşmez). */
  StoreFinder.prototype._withDistance = function (stores) {
    if (!this.userPos) return stores.slice();
    var pos = this.userPos;
    return stores.map(function (s) {
      var c = Object.create(s);
      c._km = (typeof s.lat === 'number' && typeof s.lng === 'number')
        ? haversineKm(pos, { lat: s.lat, lng: s.lng })
        : null;
      return c;
    }).sort(function (a, b) {
      if (a._km === null && b._km === null) return 0;
      if (a._km === null) return 1;
      if (b._km === null) return -1;
      return a._km - b._km;
    });
  };

  /* ---- Şehir / ilçe seçenekleri ---- */
  StoreFinder.prototype._buildCityOptions = function () {
    var cities = {};
    this.stores.forEach(function (s) { if (s.city) cities[s.city] = true; });
    var sorted = Object.keys(cities).sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    var html = '<option value="">Şehir seçin</option>';
    sorted.forEach(function (c) { html += '<option value="' + esc(c) + '">' + esc(c) + '</option>'; });
    this.citySel.innerHTML = html;
  };
  StoreFinder.prototype._buildDistrictOptions = function () {
    var city = this.citySel.value;
    var set = {};
    this.stores.forEach(function (s) { if (s.city === city && s.district) set[s.district] = true; });
    var sorted = Object.keys(set).sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    var html = '<option value="">Tümü</option>';
    sorted.forEach(function (d) { html += '<option value="' + esc(d) + '">' + esc(d) + '</option>'; });
    this.districtSel.innerHTML = html;
    this.districtSel.disabled = sorted.length === 0;
  };

  /* ---- Ana render ---- */
  StoreFinder.prototype.render = function (forceStock) {
    var v = this._selectedVariant();
    var city = this.citySel.value;

    // Varyant yoksa uyar
    if (!v) { this._syncVariantUI(); }

    var self = this;
    var isNear = this.nearMode && !!this.userPos;
    var filtered;

    if (isNear) {
      // Konum modu: şehir filtresi yok. Tüm mağazalar mesafeye göre sıralanır;
      // kaç tanesinin listeleneceğine stok bilindikten SONRA karar verilir
      // (stoklu mağaza 6. sırada olabilir — baştan kesersek kaçardı).
      filtered = this._withDistance(this.stores);
    } else {
      // Şehir seçili değilse boş durum
      if (!city) {
        this._setStates({ empty: 'Mağazaları görmek için şehir seçin.' });
        this.list.innerHTML = '';
        return;
      }
      var district = this.districtSel.value;
      filtered = this.stores.filter(function (s) {
        return s.city === city && (!district || s.district === district);
      });
      // Konum alınmışsa şehir içinde de yakından uzağa sırala
      if (this.userPos) filtered = this._withDistance(filtered);
    }

    if (!filtered.length) {
      this._setStates({
        empty: isNear ? 'Yakınınızda mağaza bulunamadı.' : 'Bu bölgede mağaza bulunamadı.'
      });
      this.list.innerHTML = '';
      return;
    }

    /* Listeyi çiz. Konum modunda önce stoklu mağazaları süz, yoksa en
       yakınları göster; durum metnini de buna göre yaz. */
    function ciz(stockMap) {
      var list = filtered;
      if (isNear) {
        list = self._pickNearest(filtered, stockMap);
        if (stockMap) {
          self._setGeoStatus(
            self._nearInStock
              ? 'Size en yakın, bu bedenin bulunduğu mağazalar.'
              : 'Bu beden yakınınızdaki mağazalarda bulunmuyor. En yakın mağazalar listeleniyor.',
            self._nearInStock ? 'ok' : 'warn'
          );
        } else {
          self._setGeoStatus('Size en yakın mağazalar listeleniyor.', 'ok');
        }
      }
      self._renderList(list, stockMap);
    }

    // Varyant yoksa stok çekmeden sadece mağazaları listele
    if (!v) {
      ciz(null);
      this._setStates({});
      return;
    }

    var cached = this._stockCache[v.id];
    if (cached && !forceStock) {
      ciz(cached);
      this._setStates({});
      return;
    }

    this._setStates({ loading: true });
    this._fetchStock(v).then(function (stockMap) {
      self._stockCache[v.id] = stockMap;
      ciz(stockMap);
      self._setStates({});
    }).catch(function () {
      ciz(null);  // stok alınamadıysa yine listele, rozet gösterme
      self._setStates({ error: true });
    });
  };

  /* Konum modunda listelenecek mağazaları seçer.
     Önce stoğu olanlar (yakından uzağa); hiçbirinde yoksa en yakınlar.
     Hangi yolun seçildiği _nearInStock bayrağında tutulur. */
  StoreFinder.prototype._pickNearest = function (sorted, stockMap) {
    if (!stockMap) {
      this._nearInStock = false;
      return sorted.slice(0, this.nearLimit);
    }
    var stoklu = sorted.filter(function (s) {
      var q = stockMap[s.code];
      return typeof q === 'number' && q > 0;
    });
    this._nearInStock = stoklu.length > 0;
    return (this._nearInStock ? stoklu : sorted).slice(0, this.nearLimit);
  };

  StoreFinder.prototype._setStates = function (opts) {
    this.emptyEl.hidden   = !opts.empty;
    if (opts.empty) this.emptyEl.textContent = opts.empty;
    this.loadingEl.hidden = !opts.loading;
    this.errorEl.hidden   = !opts.error;
  };

  /* ---- Liste çizimi ---- */
  StoreFinder.prototype._renderList = function (stores, stockMap) {
    var self = this;
    this.list.innerHTML = stores.map(function (s) {
      var badge = '';
      if (stockMap) {
        var qty = stockMap[s.code];
        badge = self._badge(typeof qty === 'number' ? qty : 0);
      }
      var maps = s.maps || ('https://www.google.com/maps/search/?api=1&query=' +
                 encodeURIComponent((s.name || '') + ' ' + (s.address || '')));
      var phone = (s.phone || '').replace(/\s+/g, '');
      // Konum alındıysa ilçenin yanında kuş uçuşu mesafe
      var meta = s.district ? esc(s.district) : '';
      if (typeof s._km === 'number') {
        meta += (meta ? ' · ' : '') +
          '<span class="store-finder__km">' + esc(formatKm(s._km)) + '</span>';
      }
      return '' +
        '<li class="store-finder__item">' +
          '<div class="store-finder__item-main">' +
            '<h3 class="store-finder__store-name">' + esc(s.name || '') + '</h3>' +
            (meta ? '<span class="store-finder__store-dist">' + meta + '</span>' : '') +
            (s.address ? '<p class="store-finder__store-addr">' + esc(s.address) + '</p>' : '') +
            '<div class="store-finder__actions">' +
              (phone ? '<a class="store-finder__act" href="tel:' + esc(phone) + '">Ara</a>' : '') +
              '<a class="store-finder__act" href="' + esc(maps) + '" target="_blank" rel="noopener">Yol Tarifi</a>' +
            '</div>' +
          '</div>' +
          (badge ? '<div class="store-finder__item-stock">' + badge + '</div>' : '') +
        '</li>';
    }).join('');
  };

  StoreFinder.prototype._badge = function (qty) {
    var cls, label;
    if (qty <= 0) { cls = 'is-out';  label = 'Stokta yok'; }
    else if (qty <= this.lowThreshold) { cls = 'is-low'; label = 'Son ürünler'; }
    else { cls = 'is-in'; label = 'Stokta var'; }
    return '<span class="store-finder__badge ' + cls + '">' +
             '<span class="store-finder__dot"></span>' + label +
           '</span>';
  };

  /* ---- Stok kaynağı ----
     Öncelik sırası:
       1) Varyanta gömülü metafield (entegratör yazıyor)  → sunucu gerekmez
       2) App Proxy endpoint'i                            → middleware gerekir
       3) Mock                                            → test
  -------------------------------------------------------------------- */
  StoreFinder.prototype._fetchStock = function (variant) {
    // 1) Gömülü metafield verisi varsa doğrudan kullan
    var embedded = normalizeStock(variant.stock, DEPO_ESLESME);
    if (embedded) return Promise.resolve(embedded);

    if (this.mock || !this.endpoint) {
      return Promise.resolve(this._mockStock(variant));
    }
    var params = new URLSearchParams({
      barcode: variant.barcode || '',
      sku: variant.sku || '',
      variant_id: String(variant.id)
    });
    return fetch(this.endpoint + '?' + params.toString(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        // Kontrat: { ok:true, stores: { "STORE_CODE": { qty:5 } | 5 } }
        var out = {};
        var src = (data && data.stores) || {};
        Object.keys(src).forEach(function (code) {
          var val = src[code];
          out[code] = (typeof val === 'number') ? val : (val && val.qty) || 0;
        });
        return out;
      });
  };

  // Deterministik sahte stok (varyant + mağaza koduna göre) — demo/test için
  StoreFinder.prototype._mockStock = function (variant) {
    var out = {};
    var seed = String(variant.id);
    this.stores.forEach(function (s) {
      var h = 0, str = seed + '|' + s.code;
      for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) & 0xffff; }
      out[s.code] = h % 8; // 0..7
    });
    return out;
  };

  /* --------------------------------------------------------------------
     Metaobject / metafield alanları JSON'a bazen düz string yerine OBJE
     olarak düşer (rich_text_field, {"value": "..."}, {"children":[...]}).
     Bu durumda şablonda "[object Object]" görünüyordu. Aşağıdaki yardımcı
     her tipi güvenli biçimde okunabilir metne çevirir.
     -------------------------------------------------------------------- */
  function textOf(val, depth) {
    depth = depth || 0;
    if (val === null || val === undefined || depth > 6) return '';
    if (typeof val === 'string') return stripTags(val);
    if (typeof val === 'number' || typeof val === 'boolean') return String(val);
    if (Array.isArray(val)) {
      return val.map(function (x) { return textOf(x, depth + 1); })
                .filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
    }
    if (typeof val === 'object') {
      // Rich text / JSON alan yapıları
      if (typeof val.value === 'string') return stripTags(val.value);
      if (val.children) return textOf(val.children, depth + 1);
      if (val.value !== undefined) return textOf(val.value, depth + 1);
      if (typeof val.text === 'string') return stripTags(val.text);

      // Adres objesi ( {address1, city, zip...} gibi ) — bilinen sırayla birleştir
      var order = ['address1', 'address2', 'line1', 'line2', 'street', 'neighbourhood',
                   'mahalle', 'district', 'ilce', 'city', 'sehir', 'zip', 'postal_code'];
      var parts = [], seen = {};
      order.forEach(function (k) {
        if (typeof val[k] === 'string' && val[k].trim()) { parts.push(val[k].trim()); seen[k] = true; }
      });
      if (!parts.length) {
        Object.keys(val).forEach(function (k) {
          if (seen[k]) return;
          if (typeof val[k] === 'string' && val[k].trim()) parts.push(val[k].trim());
        });
      }
      return stripTags(parts.join(', '));
    }
    return '';
  }

  function stripTags(s) {
    return String(s)
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/(p|div|li)>/gi, ' ')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* --------------------------------------------------------------------
     NEBIM DEPO KODU → MAĞAZA KODU
     Entegratör metafield'a Nebim'in kendi depo kodlarını (M23, M30…)
     yazarsa burada bizim kodlarımıza (IZM-MAVIBAHCE…) çevriliyor.
     Zaten bizim kodlarımızı yazıyorsa bu tablo devreye girmez.
     ⚠️ Yıldızlı satırlar müşteri teyidi bekliyor.
     -------------------------------------------------------------------- */
  var DEPO_ESLESME = {
    'M27':   'ADN-ZIYAPASA',      // ADA Ziyapaşa CAD.
    'M14':   'ADN-M1',            // ADA M1 AVM
    'B12':   'ADY-PARK',          // ⚠️ Adıyaman Bayi
    'M18':   'ANK-ANKAMALL',      // ANK Ankamall AVM
    'M35':   'ANT-AKDENIZPARK',   // ⚠️ ANT Alanya AVM
    'M16':   'ANT-MALLOFANTALYA', // ANT Mall Of AVM
    'M34':   'ANT-NOVAMALL',      // ANT Novamall AVM
    'M08':   'ANT-MARKANTALYA',   // ANT MarkAntalya AVM
    'M19':   'ANT-MIGROS',        // ANT Migros AVM
    'M20':   'ANT-OZDILEKPARK',   // ANT ÖzdilekPark AVM
    'B13':   'AYD-OPSMALL',       // ⚠️ Aydın Bayi
    'M15':   'BUR-SURYAPI',       // BUR Sur Yapı AVM
    'BY008': 'DNZ-ULUS',          // ⚠️ Denizli Bayi
    'M33':   'EDR-ERASTA',        // EDİ Erasta AVM
    'M24':   'IST-FORUM',         // İSTE Forum İstanbul AVM
    'M32':   'IST-MALTEPEPARK',   // İSTA MaltepePark AVM
    'M21':   'IST-MARMARAPARK',   // İSTE MarmaraPark AVM
    'M07':   'IST-OZDILEKPARK',   // İSTE ÖzdilekPark AVM
    'M30':   'IZM-AGORA',         // İZM Agora AVM
    'M25':   'IZM-ISTINYEPARK',   // İZM İstinyePark AVM
    'M23':   'IZM-MAVIBAHCE',     // İZM Mavibağçe AVM
    'M13':   'IZM-OPTIMUM',       // İZM Optimum AVM
    'M22':   'MRS-FORUM',         // MER Forum AVM
    'M26':   'TRB-FORUM'          // TRA Forum AVM
    // Gösterilmeyecekler (M11 İnternet, M1101 Trendyol, M001 Toptan,
    // F002-F006/FM001 Garaj) bilerek listede yok — eşleşmeyen kod atlanır.
  };

  /* Metafield stok verisini { magazaKodu: adet } biçimine indirger.
     Kabul edilen girdiler:
       {"ts":"...","stok":{"M23":5}}   |   {"M23":5}   |   {"IZM-MAVIBAHCE":5}
     Veri yoksa null döner (çağıran endpoint/mock'a düşer). */
  function normalizeStock(raw, map) {
    if (!raw) return null;
    var src = raw;
    if (typeof src === 'string') {
      try { src = JSON.parse(src); } catch (e) { return null; }
    }
    if (typeof src !== 'object') return null;
    if (src.stok && typeof src.stok === 'object') src = src.stok;
    else if (src.stock && typeof src.stock === 'object') src = src.stock;

    var out = {}, found = false;
    Object.keys(src).forEach(function (key) {
      if (key === 'ts') return;
      var qty = parseInt(src[key], 10);
      if (isNaN(qty)) return;
      var code = map[key] || key;   // Nebim kodu ise çevir, değilse olduğu gibi
      out[code] = qty;
      found = true;
    });
    return found ? out : {};
  }

  /* Koordinat alanı: sayı, string ("38,39" veya "38.39") veya boş olabilir.
     Geçersizse null döner — o mağaza mesafe sıralamasında sona atılır. */
  function num(v) {
    if (typeof v === 'number') return isFinite(v) ? v : null;
    if (typeof v === 'string') {
      var n = parseFloat(v.trim().replace(',', '.'));
      return isNaN(n) ? null : n;
    }
    return null;
  }

  function normalizeStores(list) {
    if (!Array.isArray(list)) return [];
    return list.map(function (s) {
      if (!s || typeof s !== 'object') return null;
      return {
        code: textOf(s.code),
        name: textOf(s.name),
        city: textOf(s.city),
        district: textOf(s.district),
        address: textOf(s.address),
        phone: textOf(s.phone),
        maps: textOf(s.maps || s.maps_url),
        lat: num(s.lat),
        lng: num(s.lng)
      };
    }).filter(function (s) { return s && (s.name || s.code); });
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify section reload (tema editörü) desteği
  document.addEventListener('shopify:section:load', initAll);

  // Widget artık variant-picker İÇİNDE (Beden etiketinin yanında) gömülü.
  // Tema, kombine ürün/varyant değişiminde bu alanı AJAX ile innerHTML
  // olarak değiştirebilir — yeni DOM parçası '__sfInit' bayrağı taşımaz.
  // MutationObserver ile böyle bir değişiklik olursa otomatik yeniden başlat.
  if ('MutationObserver' in window) {
    var sfObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-store-finder]')) ||
              (node.querySelector && node.querySelector('[data-store-finder]'))) {
            initAll(document);
            return;
          }
        }
      }
    });
    sfObserver.observe(document.body, { childList: true, subtree: true });
  }
})();